import { ajax } from 'rxjs/ajax';

import { basePostRequest } from '../../tretail/baseRequest';

export default function updatePreArrivalPreference$({
	guestEta,
	stayReasonIds,
	guests,
	comments,
	bookingId,
}) {
	const data = {};

	if (guestEta) data.guestEta = guestEta;

	if (stayReasonIds) data.stayReasonIds = stayReasonIds;

	if (guests) data.guests = guests;

	// If user explicitly clears comments, it is sent here as ""
	if (comments !== undefined) {
		data.comments = comments;
	}

	return ajax({
		...basePostRequest(),
		url: `/api/preArrivalPreference/${bookingId}`,
		withCredentials: true,
		body: {
			...data,
		},
	});
}
